import React, { useEffect, useRef } from 'react';
import { qdtComponents } from '../../config/predictionsAppConfig';

const QdtComponentPredictions = props => {
  const node = useRef(null);
  const { type, props: qProps } = props;

  useEffect(() => {
    qdtComponents.render(type, qProps, node.current);
  }, [qProps, type]);

  return <div ref={node} />;
};

export default QdtComponentPredictions;
